import React from 'react'
import style from "../../DetailContainer.module.scss"
import { TbBriefcase2 } from 'react-icons/tb'
import { BiBuilding, BiCalendar } from 'react-icons/bi'
import { IoLocationOutline } from 'react-icons/io5'

const ExperienceCard = ({
  position,
  exp,
  company,
  industry,
  dept,
  location,
}) => (
  <div className={style.content}>
    <div className={style.candidateTimelineContainer}>
      <div className={style.timelineItem}>
        <div className={style.timelineDot}></div>

        <div className={style.timelineContent}>
          <div className={style.role}>
            <TbBriefcase2 /> {position || "-"} |{" "}
            <BiCalendar /> {exp || "-"}
          </div>

          <div className={style.companyName}>
            <BiBuilding /> {company || "-"}
          </div>

          <div className={style.details}>
            Industry : {industry || "-"} | Department : {dept || "-"}
          </div>

          <div className={style.companyLocation}>
            <IoLocationOutline /> {location || "-"}
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default ExperienceCard
